module.exports = __webpack_public_path__ + "media/images/category/feature/coj_c/coj_c-1-47bcddffe1d0c88cd0cff82e74c17972.jpg";